import type { UseQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';
import { toast } from 'sonner';

type QueryErrorSource = Pick<UseQueryResult, 'isError' | 'errorUpdatedAt'>;

/**
 * Toasts `message` whenever the query (re)fails. Keys on
 * errorUpdatedAt — a repeat failure of the same query key never toggles
 * isError, but each failure bumps errorUpdatedAt and must re-toast (semantics
 * proven out in fiu-utr-filing). The stable toast id (defaults to the message)
 * dedupes repeats instead of stacking.
 */
export const useQueryErrorToast = ({ isError, errorUpdatedAt }: QueryErrorSource, message: string, toastId?: string): void => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: errorUpdatedAt is a deliberate extra trigger — see the doc comment above
  useEffect(() => {
    if (isError) toast.error(message, { id: toastId ?? message });
  }, [isError, errorUpdatedAt, message, toastId]);
};
